const stringValue = (value) =>
  typeof value === "string" ? value.trim() : value;

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return true;
};

const getFirstValue = (source, paths) => {
  for (const path of paths) {
    const value = path
      .split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        source,
      );
    if (hasValue(value)) return value;
  }
  return null;
};

const isRegistrationComplete = (profile) =>
  profile?.registrationCompleted === true ||
  String(profile?.registrationCompleted).toLowerCase() === "true";

export const PROFILE_COMPLETION_FIELDS = [
  {
    key: "avatar",
    label: "Profile photo",
    paths: [
      "avatarURL",
      "avatarUrl",
      "profilePicture",
      "picture",
      "avatarId",
      "profile.avatarURL",
      "profile.avatarUrl",
      "profile.profilePicture",
      "profile.avatarId",
    ],
  },
  {
    key: "bio",
    label: "Bio",
    paths: ["bio", "profile.bio"],
  },
  {
    key: "gender",
    label: "Gender",
    paths: ["gender", "profile.gender"],
  },
  {
    key: "pronouns",
    label: "Pronouns",
    paths: ["pronouns", "profile.pronouns"],
  },
  {
    key: "ethnicity",
    label: "Ethnicity",
    paths: ["ethnicity", "race", "profile.ethnicity", "profile.race"],
  },
  {
    key: "accessibility",
    label: "Accessibility details",
    paths: [
      "disabilityStatus",
      "disabilities",
      "disability",
      "profile.disabilityStatus",
      "profile.disabilities",
      "profile.disability",
    ],
  },
];

export const getProfileCompletion = (profile) => {
  const fields = PROFILE_COMPLETION_FIELDS;

  if (!profile || typeof profile !== "object") {
    return {
      percent: 0,
      completed: 0,
      total: fields.length,
      missing: fields,
    };
  }

  const missing = [];
  const completedFields = fields.filter((field) => {
    const complete = hasValue(
      stringValue(getFirstValue(profile, field.paths || [])),
    );
    if (!complete) missing.push(field);
    return complete;
  });

  const total = fields.length;
  const completed = completedFields.length;
  const optionalPercent = total > 0 ? completed / total : 1;
  const percent = isRegistrationComplete(profile)
    ? Math.min(100, 60 + Math.round(optionalPercent * 40))
    : total > 0
      ? Math.round(optionalPercent * 100)
      : 100;

  return {
    percent,
    completed,
    total,
    missing,
  };
};
